import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import trainingPerformedListAction from './trainingPerformedList.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../trainingPerformedObject'
import trainingObject from '../../training/trainingObject'

export const trainingPerformedExpression = expression(trainingPerformedObject.shape)

const trainingPerformedListDefinition = defineAction({
  ...trainingPerformedListAction,

  input: z.object({
    filter: trainingPerformedExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: z.string().nullish(),
    order: z.string().nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(trainingPerformedObject.extend({ training: trainingObject })),
    count: z.number(),
  }),
})

export default trainingPerformedListDefinition
